import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';


import { PageTitle } from '@src/components/common';
import EditAdminUrl from '@src/components/common/Display/EditAdminUrl';
import StatusLabels from '@src/components/common/Display/titles/StatusLabels';
import { useTrackContentView } from '@src/hooks/effects/useTrackContentView';

import {
    Content,
    ContentInfoHeader,
    Duration,
} from './partials';

import '@src/css/article_id.scss';
import '@src/css/global.scss';

import './styles.scss';

export const ContentViewSideImg = (props) => {
    const {
        category,
        categories,
        className,
        children,
        content,
        duration,
        id,
        resourceType,
        imgAlt,
        imgUrl,
        leftImage,
        products,
        platformProducts,
        publishedAt,
        noContentInfo,
        roleType,
        salesChannels,
        states,
        expiredAt,
        status,
        take20,
        title,
        updatedAt,
        webibarTime,
        webinar,
        webinarDate,
        webinarBadge,
    } = props;

    const colWrapperClassName = classNames(className, 'post_page content-view-side-img-container pt-4');

    const firstColClassNames = classNames({
        'left-column': !leftImage,
        'right-column': leftImage,
        'order-2 order-lg-1': !leftImage,
        'order-2': leftImage,
    });

    const secondColClassNames = classNames({
        'left-column': leftImage,
        'right-column': !leftImage,
        'order-1 order-lg-2': !leftImage,
        'order-1': leftImage,
    });

    useTrackContentView({ id, resourceType, title });

    return (
        <Col>
            <PageTitle title={title} />
            <Row>
                <Col>
                    <EditAdminUrl resourceType={resourceType} id={id} />
                </Col>
            </Row>
            <Row>
                <Col id={id} className={colWrapperClassName}>
                    <Card className="ml-card">
                        <Card.Body>
                            <Row className="article_id_page">
                                <Col lg={imgUrl ? 7 : 12} className={firstColClassNames}>
                                    <div className="text-container">
                                        {
                                            take20
                                            && <h4>Upcoming webinar</h4>
                                        }
                                        {
                                            webinar
                                            && webinarBadge
                                        }
                                        <h1>
                                            <StatusLabels
                                                expiredAt={expiredAt}
                                                status={status}
                                                publishedAt={publishedAt}
                                            />
                                            {title}
                                        </h1>
                                        {
                                            webinar
                                            && (
                                                <>
                                                    <h4 className="smaller">{webinarDate}</h4>
                                                    {webibarTime && <h4 className="smaller">{webibarTime}</h4>}
                                                </>
                                            )
                                        }
                                        {
                                            duration
                                            && <Duration duration={duration} />
                                        }
                                        {
                                            noContentInfo
                                            || <ContentInfoHeader
                                                alertCategory={category}
                                                categories={categories}
                                                products={products}
                                                platformProducts={platformProducts}
                                                publishedAt={publishedAt}
                                                roleType={roleType}
                                                salesChannels={salesChannels}
                                                states={states}
                                                webinar={webinar}
                                                updatedAt={updatedAt}
                                            />
                                        }

                                        {
                                            content
                                            && <Content content={content} />
                                        }
                                        {
                                            children
                                            && (
                                                <div className="children-container">
                                                    { children }
                                                </div>
                                            )
                                        }
                                    </div>
                                </Col>
                                {
                                    imgUrl
                                    && (
                                        <Col lg={5} className={secondColClassNames}>
                                            <div
                                                role="img"
                                                aria-label={imgAlt}
                                                title={imgAlt}
                                                className="img-container"
                                                style={{ backgroundImage: `url(${imgUrl})` }}
                                            />
                                        </Col>
                                    )
                                }
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Col>
    );
};

ContentViewSideImg.propTypes = {
    category: PropTypes.string,
    categories: PropTypes.arrayOf(PropTypes.object),
    children: PropTypes.node,
    className: PropTypes.string,
    content: PropTypes.string,
    duration: PropTypes.number,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    resourceType: PropTypes.string,
    imgAlt: PropTypes.string,
    imgUrl: PropTypes.string,
    leftImage: PropTypes.bool,
    noContentInfo: PropTypes.bool,
    products: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.object),
        PropTypes.shape({
            states: PropTypes.arrayOf(PropTypes.object),
        }),
    ]),
    platformProducts: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.object),
        PropTypes.shape({
            states: PropTypes.arrayOf(PropTypes.object),
        }),
    ]),
    publishedAt: PropTypes.string,
    roleType: PropTypes.string,
    salesChannels: PropTypes.arrayOf(PropTypes.object).isRequired,
    states: PropTypes.arrayOf(PropTypes.object).isRequired,
    expiredAt: PropTypes.string,
    status: PropTypes.string,
    take20: PropTypes.bool,
    title: PropTypes.string,
    webinar: PropTypes.bool,
    webinarDate: PropTypes.node,
    webibarTime: PropTypes.node,
    webinarBadge: PropTypes.node,
    updatedAt: PropTypes.string,
};
